import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["appId", "providerKey", "registry", "children", "onComplete", "onCancel", "portalId", "appName", "oAuthScopes", "mcpParams", "customParams", "config", "modalSettings", "use", "size"];
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { defaultRegistry, useResolvedProvider } from './registry';
import { jsx as _jsx } from "react/jsx-runtime";
export const ConnectAccount = _ref => {
  let {
      appId,
      providerKey,
      registry = defaultRegistry,
      children,
      onComplete,
      onCancel,
      portalId,
      appName,
      oAuthScopes,
      mcpParams,
      customParams,
      config,
      modalSettings,
      use,
      size
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    components,
    isLoading
  } = useResolvedProvider(appId, providerKey, registry);
  if (isLoading) {
    return /*#__PURE__*/_jsx(LoadingButton, {
      use: use,
      size: size,
      disabled: true,
      loading: true,
      children: children
    });
  }
  if (!components) {
    console.error(providerKey ? `[ConnectAccount] No auth provider found for appId: ${appId} with providerKey: "${providerKey}"` : `[ConnectAccount] No auth provider found for appId: ${appId}`);
    return null;
  }
  const {
    Button
  } = components;
  return /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
    use: use,
    size: size,
    appId: appId,
    portalId: portalId,
    appName: appName,
    oAuthScopes: oAuthScopes,
    mcpParams: mcpParams,
    customParams: customParams,
    config: config,
    modalSettings: modalSettings,
    onComplete: onComplete,
    onCancel: onCancel,
    children: children
  }));
};
ConnectAccount.displayName = 'ConnectAccount';